import { getInvoicedEcommerces } from '@/api/invoicing-api'
import { useAppSelector } from '@/redux/hooks'
import { Roles } from '@/utils'
import { useQuery } from '@tanstack/react-query'

// Which portals REVER invoices, for the store in view or for the whole group. Most groups have
// portals with no billing of their own (warranty, internal), and offering those leads nowhere.
export function useInvoicedPortals() {
  const selectedEcommerce = useAppSelector(
    (s) => s.generalData.selectedEcommerce
  )
  const selectedGroup = useAppSelector((s) => s.generalData.selectedGroup)
  const user = useAppSelector((s) => s.userApi.getMe.response.user)
  const ownGroup = user?.group ?? ''
  // REVER staff carry "*" as their group, so theirs is whichever one they picked.
  const group = ownGroup === '*' ? (selectedGroup ?? '') : ownGroup
  const scope = selectedEcommerce
    ? { ecommerceId: selectedEcommerce }
    : { group }

  // Billing is admin-only on both sides, so anyone else would only collect a 403.
  const enabled =
    user?.role === Roles.ReadWrite && (!!selectedEcommerce || !!group)

  const invoicedQuery = useQuery({
    queryKey: ['invoicedPortals', selectedEcommerce, group],
    queryFn: () => getInvoicedEcommerces(scope),
    enabled,
    staleTime: 1000 * 60 * 10
  })

  return {
    invoicedPortals: invoicedQuery.data?.ecommerce_ids ?? [],
    // A disabled query stays pending forever, which would leave the page on its spinner.
    loadingInvoicedPortals: enabled && invoicedQuery.isPending,
    // Told apart from an empty answer: a failed lookup must not read as "nothing to bill".
    portalsError: invoicedQuery.isError,
    reloadInvoicedPortals: () => invoicedQuery.refetch()
  }
}
